"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    Login: {
        Email: 'Login/Email',
        Password: 'Login/Password',
        Submit: 'Login/Submit',
    }
};
